import { showValidationErrorMessage } from "./showValidationErrorMessage";

export const buyValidationOptions = {
  rules: {
    "answerData[firstName]": {
      required: true,
    },
    "answerData[lastName]": {
      required: true,
    },
    // "answerData[postalCode]": {
    //     postcodeUK: true
    // },
    "answerData[street]": {
      required: true,
    },
    "answerData[city]": {
      required: true,
    },
    "answerData[county]": {
      required: true,
    },
    "answerData[countryCode]": {
      required: true,
      countryCode: true,
    },
    "answerData[day]": {
      day: true,
    },
    "answerData[month]": {
      month: true,
    },
    "answerData[year]": {
      year: true,
    },
    promoCode: {
      alphanumchar: true,
      required: true,
    },
    // "questions[postal-code]": {
    //     postcodeUK: true
    // },
    "answerData[eligibility]": {
      required: true,
    },
    "answerData[lockingRequirements]": {
      required: true,
    },
    "answerData[hasBikeCard]": {
      required: true,
    },
  },
  errorPlacement: showValidationErrorMessage,
};
